import React, { useState } from 'react';
import './KanvanViwew.scss';
import Kanvan from './Kanvan/Kanvan';
import EditarTarea from '../formularios/EditarTarea';

const KanvanViwew = ({ data, setData, filtros,setFiltros }) => {
    const [tareaEdit, setTareaEdit] = useState(null);

    return (
        <div className='KanvanViwew'>
            <Kanvan data={data} setData={setData} filtros={filtros} onCardClick={setTareaEdit} setFiltros={setFiltros}/>
            <EditarTarea
                open={!!tareaEdit}
                onClose={() => setTareaEdit(null)}
                tarea={tareaEdit}
                data={data}
                setData={setData}
            />
        </div>
    );
};
export default KanvanViwew;